export default "__VITE_ASSET__CQW5gvXe__"